import { useScrollReveal, useScrollRevealGroup } from '@/hooks/useScrollReveal';

const launchSteps = [
  {
    num: '1',
    icon: 'ri-search-eye-line',
    title: 'Разбираем вашу нишу',
    desc: 'Изучаем продукт, географию, средний чек и текущую воронку продаж.',
  },
  {
    num: '2',
    icon: 'ri-user-settings-line',
    title: 'Согласовываем целевой лид',
    desc: 'Определяем, какие параметры должен иметь клиент, за которого вы платите.',
  },
  {
    num: '3',
    icon: 'ri-settings-3-line',
    title: 'Настраиваем систему',
    desc: 'Подключаем источники, сценарии ИИ, напоминания и передачу заявок.',
  },
  {
    num: '4',
    icon: 'ri-play-circle-line',
    title: 'Запускаем тест',
    desc: 'Получаем первые обращения, проверяем качество и корректируем настройки.',
  },
  {
    num: '5',
    icon: 'ri-line-chart-line',
    title: 'Масштабируем результат',
    desc: 'Увеличиваем объём заявок из каналов с подтверждённой экономикой.',
  },
];

export default function LTKLaunch() {
  const { ref: labelRef, revealed: labelRevealed } = useScrollReveal();
  const { ref: titleRef, revealed: titleRevealed } = useScrollReveal({ delay: 100 });
  const { containerRef: stepsRef, revealedCount: stepsRevealed } = useScrollRevealGroup<HTMLDivElement>(5);

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="text-center mb-12 md:mb-16">
          <span ref={labelRef} className={`text-[12px] font-semibold uppercase tracking-[0.18em] text-primary-600 reveal-fade-up ${labelRevealed ? 'revealed' : ''}`}>
            Запуск
          </span>
          <h2 ref={titleRef} className={`mt-4 font-display font-extrabold text-[34px] md:text-[46px] leading-[1.1] tracking-tightest text-foreground-950 reveal-fade-up ${titleRevealed ? 'revealed' : ''}`}>
            Как запускаем работу
          </h2>
        </div>

        <div ref={stepsRef} className="relative max-w-3xl mx-auto">
          <div className="absolute left-[22px] top-10 bottom-10 w-px bg-background-300/60 hidden md:block" />

          <div className="flex flex-col gap-8 md:gap-10">
            {launchSteps.map((step, i) => (
              <div key={step.num} className={`relative flex gap-5 md:gap-7 items-start reveal-fade-up ${i < stepsRevealed ? 'revealed' : ''}`} style={i < stepsRevealed ? { transitionDelay: `${i * 130}ms` } : undefined}>
                <div className="relative z-10 flex-shrink-0 w-11 h-11 rounded-full bg-primary-500 flex items-center justify-center font-display font-bold text-sm text-background-50">
                  {step.num}
                </div>

                <div className="flex-1 bg-background-100 rounded-2xl border border-background-200/70 p-5 md:p-6 hover:border-primary-500/40 transition-all duration-300">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center text-primary-600">
                      <i className={`${step.icon} text-sm`}></i>
                    </span>
                    <h3 className="font-display font-bold text-[17px] text-foreground-950">{step.title}</h3>
                  </div>
                  <p className="text-[14.5px] text-foreground-500 leading-relaxed">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}